import {
  action,
  computed,
  makeObservable,
  observable,
  onBecomeObserved,
} from "mobx"

import { catchErrors, projectsApi } from "@src/shared/api"
import { Pagination } from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"

class ProjectsCollection extends loading(
  ["fetch"],
  CollectionWithPagination<any>,
) {
  search = ""

  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
      search: observable,
      searchedValue: computed,
      selectOptions: computed,
    })

    this.setPagination({ limit: 100 })

    onBecomeObserved(this, "state", this.load)
  }

  async fetch(req: { page: number }) {
    try {
      const { data: { data: response } = {} } = await projectsApi.getProjects(
        undefined,
        this.calcOffset(req.page),
        this.pageSize,
      )

      if (response) {
        return {
          data: response.data as any[],
          pagination: response.pagination as Pagination,
        }
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }

  get filter() {
    return undefined
  }

  get searchedValue() {
    return this.search
      ? this.items.filter((i) =>
          i.id.toLowerCase().includes(this.search.toLowerCase()),
        )
      : this.items
  }

  get selectOptions() {
    return this.items.map((i) => ({
      label: i.name,
      value: i.id,
    }))
  }
}

export default ProjectsCollection
